// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"1527":"cac3387d","6294":"f1d01866"}[chunkId] + ".chunk.css");